// extracted by mini-css-extract-plugin
module.exports = {"viz-container":"GlobeAnimation_viz-container___PIfr"};